import { useSelector } from "react-redux";
import salesSettingsHelper from "../services/salesSettingsHelper";
import { selectAllUniqueWebsites } from "../sub-modules/opportunities/store/selectors";

function useStaticListSizeQuota() {
    const numberOfTrackedSites = useSelector(selectAllUniqueWebsites)?.length;
    const limitOfWebsitesToTrack = salesSettingsHelper.getQuotaLimit();

    return {
        numberOfTrackedSites,
        limitOfWebsitesToTrack,
        isListSizeQuotaReached: numberOfTrackedSites >= limitOfWebsitesToTrack,
    };
}

export default useStaticListSizeQuota;
